"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleRect = exports.tileWithBorders = exports.simpleConfig = void 0;
const euclid_1 = require("@reality/euclid");
function simpleConfig(width, height, sheetName) {
    let config = {};
    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const layerId = `${sheetName}.${x}.${y}`;
            config[layerId] = {
                layerID: layerId,
                resourceID: sheetName,
                sprite: { x, y },
            };
        }
    }
    return config;
}
exports.simpleConfig = simpleConfig;
function simpleRect(resourceID, baseName, startCoord, width, height) {
    let config = {};
    for (let y = startCoord.y; y < startCoord.y + height; y++) {
        for (let x = startCoord.x; x < startCoord.x + width; x++) {
            const layerID = `${baseName}(x${x},x${y})`;
            config[layerID] = {
                layerID,
                resourceID,
                sprite: { x, y },
            };
        }
    }
    return config;
}
exports.simpleRect = simpleRect;
const suffixToDelta = {
    tl: { x: -1, y: -1 },
    t: { x: 0, y: -1 },
    tr: { x: 1, y: -1 },
    l: { x: -1, y: 0 },
    r: { x: 1, y: 0 },
    bl: { x: -1, y: 1 },
    b: { x: 0, y: 1 },
    br: { x: 1, y: 1 },
};
/**
 * Generates the config for the classic 3x3 of sprites with a standard naming convention
 *
 * @param startX x coord of center of the 3x3 (the base sprite)
 * @param startY y coord of center of the 3x3 (the base sprite)
 * @param baseName name of the center sprite, rest are named with standard suffixes
 */
function tileWithBorders(resourceID, baseName, startCoord) {
    let config = {};
    config[baseName] = {
        layerID: baseName,
        resourceID,
        sprite: startCoord,
    };
    Object.keys(suffixToDelta).forEach((suffix) => {
        const layerID = `${baseName}_${suffix}`;
        config[layerID] = {
            layerID,
            resourceID,
            sprite: euclid_1.CoordinateUtils.add(startCoord, suffixToDelta[suffix]),
        };
    });
    return config;
}
exports.tileWithBorders = tileWithBorders;
//# sourceMappingURL=utils.js.map